// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"a59fd9212def576b","3625":"7bec47befaa5fca3","5967":"7bec47befaa5fca3","7542":"7bec47befaa5fca3","7741":"7bec47befaa5fca3"}[chunkId] + ".css";
};